export const sha256HashString = async (value: string): Promise<String> => {
    const digest = await window.crypto.subtle.digest('sha-256', new TextEncoder().encode(value));
    return btoa(String.fromCharCode(...new Uint8Array(digest)));
};
